import React from "react";
import { Profile } from "./molecules/Profile";
import { MobilePropertyValue } from "./molecules/MobilePropertyValue";
import { MobileDownpayment } from "./molecules/MobileDownpayment";
import { MobileZip } from "./molecules/MobileZip";
import IconButton from "@mui/material/IconButton";
import { EditIcon } from "../../atoms/icons/edit";
import { AvailableLoanOptionsIcon } from "../../atoms/icons/available-loan-options";
import { LoanComparisonIcon } from "../../atoms/icons/loan-comarison";
import { QuoteCardMobile } from "./molecules/QuoteCardMobile";
import { CompareViewAccordion, PaperItem } from "./molecules/CustomAccordion";
import {
  COMPARE_TOTAL_CASH_TO_CLOSE_ITEMS,
  COMPARE_TOTAL_CLOSING_COST_ITEMS,
  isRefinance,
} from "../../util/compare_utils";
import { useState } from "react";
import { styled } from "@mui/material";
import { TooltipCombo } from "./molecules/TooltipCombo";

const RelativeParent = styled("div")`
  position: relative;
  width: 100%;
`;

const ToolTipComparePositioner = styled("div")`
  position: absolute;
  top: 4px;
  left: 18px;
`;

export const ComparisonViewMobile = ({
  comparedQuotes,
  setIsComparisonView,
  setShowAddModal,
  enteredData,
  setShowSettingsModal,
  setComparedId,
  isComparedIds,
  onSelect,
  onEditClick,
  content,
}) => {
  const [openArray, setOpenArray] = useState([]);
  const { price, downPayment, zip } = enteredData;
  return (
    <div className="comparison-mobile">
      <div className="top-stats-bar">
        <Profile />
        <MobilePropertyValue price={price} />
        <MobileDownpayment downpayment={downPayment} />
        <MobileZip zip={zip} />
        <div className="bold">...</div>
        <IconButton
          onClick={() => setShowSettingsModal(true)}
          aria-label="Edit loan selections"
        >
          <EditIcon fill="white" width="24" height="24" />
        </IconButton>
      </div>
      <div className="comparison-main-section-wrapper">
        <div className="comparison-available-options">
          <div className="flex-row align-items-center">
            <AvailableLoanOptionsIcon className="margin-right" fill="white" />
            <div className="bold">Available Loan Options</div>
          </div>
          <IconButton
            aria-label="delete"
            onClick={() => setIsComparisonView(false)}
          >
            <EditIcon fill="white" width="24" height="24" />
          </IconButton>
        </div>
        <div className="comparison-cards-wrapper">
          <div className="loan-icon-wrapper">
            <LoanComparisonIcon fill="white" />
            Loan Comparison
          </div>
          <div className="quote-cards-wrapper">
            <div className="quote-headings">
              <div className="quote-card-icon-wrapper bold">Type</div>
              <div className="quote-heading-text bold">Term</div>
              <div className="quote-heading-text bold">Rate</div>
              <div className="quote-heading-text bold">APR</div>
              <div className="pie-chart-heading">
                <div className="quote-heading-stacked">Monthly Payment</div>
              </div>
              <div className="quote-heading-text">Principal</div>
              <div className="quote-heading-text">Interest</div>
              <RelativeParent>
                <div className="quote-heading-text">PMI</div>
                <ToolTipComparePositioner>
                  <TooltipCombo tip={content.tooltip1} />
                </ToolTipComparePositioner>
              </RelativeParent>
              <div className="quote-heading-text">Insurance</div>
              <div className="quote-heading-text quote-heading-taxes">
                Taxes
              </div>
              <CompareViewAccordion
                title="Total Closing Costs"
                openArray={openArray}
                setOpenArray={setOpenArray}
                name="ClosingCosts"
                mobile
                tooltipText={content.tooltip2}
              >
                {COMPARE_TOTAL_CLOSING_COST_ITEMS.map((item, index) => (
                  <CompareViewAccordion
                    title={item.title}
                    openArray={openArray}
                    setOpenArray={setOpenArray}
                    name={item.name}
                    isMini
                    hasIcon={!!item.subtitles.length}
                    key={item.title}
                    tooltipText={content[`tooltip${index + 3}`]}
                  >
                    {item.subtitles.map((subtitle) => (
                      <PaperItem key={subtitle}>{subtitle}</PaperItem>
                    ))}
                  </CompareViewAccordion>
                ))}
              </CompareViewAccordion>
              <CompareViewAccordion
                title="Total Cash to Close"
                name="CashToClose"
                openArray={openArray}
                setOpenArray={setOpenArray}
                customClassName="smaller-margin"
                tooltipText={content.tooltip8}
              >
                {COMPARE_TOTAL_CASH_TO_CLOSE_ITEMS.filter((item, index) => {
                  if(index !== 3) {
                    return true;
                  }
                  return !isRefinance();
                }).map((item, index) => (
                  <CompareViewAccordion
                    title={item.title}
                    openArray={openArray}
                    setOpenArray={setOpenArray}
                    name={item.name}
                    isMini
                    hasIcon={!!item.subtitles.length}
                    key={item.title}
                    tooltipText={content[`tooltip${index + 9}`]}
                  >
                    {item.subtitles.map((subtitle) =>
                      subtitle === "Down Payment" && isRefinance() ? null : (
                        <PaperItem key={subtitle}>{subtitle}</PaperItem>
                      )
                    )}
                  </CompareViewAccordion>
                ))}
              </CompareViewAccordion>
            </div>
            <div className="quote-cards">
              {comparedQuotes.map((quote) => (
                <QuoteCardMobile
                  quote={quote}
                  key={quote.id}
                  openArray={openArray}
                  setShowAddModal={setShowAddModal}
                  enteredData={enteredData}
                  setComparedId={setComparedId}
                  isComparedIds={isComparedIds}
                  onEditClick={onEditClick}
                  onSelect={() => onSelect(quote)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
